import { useLingui } from "@lingui/react/macro";

type CappedListOptions = {
  cap?: number;
  fallback?: string;
  maxStringLength?: number;
};

export function useCappedList() {
  const { t } = useLingui();

  return function formatCappedList(
    items: string[],
    { cap = 3, fallback = "-", maxStringLength }: CappedListOptions = {}
  ): string {
    if (!items.length) {
      return fallback;
    }

    const visible = items.slice(0, cap).map((string) => {
      if (maxStringLength && string.length > maxStringLength) {
        return `${string.substring(0, maxStringLength)}…`;
      }

      return string;
    });
    const rest = items.length - cap;

    if (rest <= 0) {
      return visible.join(", ");
    }

    return `${visible.join(", ")} ${t`+${rest} till`}`;
  };
}
